const labels = {
  de: {
    global: {
      headline: 'Ausstellerverzeichnis',
      searchPlugin: 'Suchen Sie hier nach Ausstellern, Produkten und News...',
      description: 'In unserem Ausstellerverzeichnis können Sie nach allen Ausstellern und Mitausstellern, Partnern und Produkten recherchieren.',
    },
    navigation: {
      woozle: 'Woozle',
      programmList: 'Programmliste',
      hallPlan: 'Hallenplan'
    },
    filter: {
      open: 'Filter einblenden',
      close: 'Filter ausblenden',
      button: 'Filtern',
      sort: 'Sortieren',
      category: 'Kategorie',
      travelDestination: 'Reiseziel',
      save: 'Speichern',
      reset: 'Zurücksetzen',
      search: {
        placeholder: 'Bitte Suchbegriff eingeben',
        submit: 'Suchen',
        reset: 'Zurücksetzen',
      },
      tree: {
        placeholder: 'durchsuchen...',
        fairGroups: '',
        clearValue: 'Filter entfernen',
        clearAll: 'Filter zurücksetzen',
        noOptions: 'Keine Filter gefunden',
        noResults: 'Keine Ergebnisse gefunden',
        noChildren: 'Keine Unterpunkte gefunden',
        fairTree: {
          headline: 'Teilmessen',
        },
        typeTree: {
          headline: 'Eintragsarten',
          products: 'Produkte',
          exhibitors: 'Aussteller',
        },
      },
      fairGroups: {
        headline: 'Themenwelten',
      },
      types: {
        headline: 'Inhalte',
      },
      categories: {
        headline: 'Kategorien',
      },
      travelDestinations: {
        headline: 'Reiseziele',
      },
      halls: {
        headline: 'Hallen',
      },
    },
    list: {
      link: 'Hallenplan',
      print: 'Drucken',
      help: 'Hilfe',
      favourites: 'Meine Merkliste',
      result: 'Ergebnis',
      results: 'Ergebnisse',
      nothingFound: 'Es wurden leider keine Ergebnisse gefunden.',
      useListTooltip: 'Listenansicht verwenden',
      useTileTooltip: 'Kachelansicht verwenden',
      linkToDetail: 'Informationen anzeigen',
      linkToDetailTooltip: 'Gehe zur Detailseite',
      linkToNewsDetail: 'News anzeigen',
      linkToAllNews: 'Alle News anzeigen',
      linkToNewsDetailTooltip: 'Gehe zur Detailseite',
      linkToHallPlan: 'im Hallenplan',
      resetFilters: 'Filter zurücksetzen',
      favouriteTooltip: {
        name: {
          singular: 'Favorit',
          plural: 'Favoriten',
        },
        detail: {
          active: 'Von Favoritenliste entfernen',
          inactive: 'Zur Favoritenliste hinzufügen',
        },
        switch: {
          active: 'Verberge die Favoritenliste',
          inactive: 'Zeige die Favoritenliste an',
        },
        clear: 'Alle Favoriten löschen',
      },
      type: {
        exhibitor: 'Aussteller',
        product: 'Produkt',
        news: 'News',
        brand: 'Marke',
      },
    },
    detail: {
      closeTooltip: 'Schließen',
      printTooltip: 'Drucken',
      mailTooltip: 'E-Mail schreiben',
      telephoneTooltip: 'Nummer anrufen',
      faxTooltip: 'Fax schreiben',
      websiteTooltip: 'Webseite aufrufen',
      fairBooths: {
        headline: 'Messestand',
        hall: 'Halle',
        booth: 'Stand',
        aisle: 'Gang',
        link: 'im Hallenplan',
        undefined: 'Undefiniert',
        ebmsState: {
          MAU: 'Mitaussteller',
          VF: 'vertretene Firma',
          AUS: 'Hauptaussteller',
        },
      },
      companyProfile: {
        headline: 'Firmenprofil',
      },
      badges: {
        headline: 'Sonderauszeichnungen',
      },
      contact: {
        headline: 'Kontakt',
      },
      pointOfContact: {
        headline: 'Ansprechpartner',
      },
      products: {
        headline: 'Produkte',
        link: 'zum Produkt',
      },
      news: {
        headline: 'News',
        link: 'zur News',
        exhibitor: 'Aussteller',
      },
      categories: {
        headline: 'Kategorien',
      },
      travelDestinations: {
        headline: 'Reiseziele',
      },
      media: {
        headline: 'Informationsmedien',
        download: 'Herunterladen',
        show: 'Jetzt ansehen',
        back: 'Zurück zum Aussteller',
      },
      brands: {
        headline: 'Marken',
      },
    },
  },
  en: {
    global: {
      headline: 'Index of exhibitors',
      searchPlugin: 'Search for exhibitors, products and news ...',
      description: 'English text about the index of exhibitors.',
    },
    navigation: {
      woozle: 'Woozle',
      programmList: 'programm list',
      hallPlan: 'hall plan'
    },
    filter: {
      open: 'Show filter',
      close: 'Hide filter',
      button: 'Filter',
      sort: 'Sort',
      category: 'Category',
      travelDestination: 'Travel dest.',
      save: 'Save',
      reset: 'Reset',
      search: {
        placeholder: 'Please enter search',
        submit: 'Search',
        reset: 'Reset',
      },
      tree: {
        placeholder: 'search...',
        clearValue: 'Clear filter',
        clearAll: 'Clear filter',
        noOptions: 'No filter found',
        noResults: 'No results found',
        noChildren: 'No children found',
        fairTree: {
          headline: 'Fairs',
        },
        typeTree: {
          headline: 'Type',
          products: 'Products',
          exhibitors: 'Exhibitors',
        },
      },
      fairGroups: {
        headline: 'Fair groups',
      },
      types: {
        headline: 'Content',
      },
      categories: {
        headline: 'Categories',
      },
      travelDestinations: {
        headline: 'Travel destinations',
      },
      halls: {
        headline: 'Halls',
      },
    },
    list: {
      link: 'Hall plan',
      print: 'Print',
      favourites: 'My favourites',
      help: 'Help',
      result: 'result',
      results: 'results',
      nothingFound: 'No matching results found.',
      useListTooltip: 'Use list view',
      useTileTooltip: 'Use tile view',
      linkToDetail: 'Show information',
      linkToDetailTooltip: 'Go to detail page',
      linkToNewsDetail: 'Show news',
      linkToAllNews: 'Show all news',
      linkToNewsDetailTooltip: 'Go to detail page',
      linkToHallPlan: 'Go to hallplan',
      resetFilters: 'Reset filters',
      favouriteTooltip: {
        name: {
          singular: 'favourite',
          plural: 'favourites',
        },
        detail: {
          active: 'Remove from favourites',
          inactive: 'Add to favourites',
        },
        switch: {
          active: 'Hide favourites',
          inactive: 'Show favourites',
        },
        clear: 'Clear all favourites',
      },
      type: {
        exhibitor: 'Exhibitor',
        product: 'Product',
        news: 'News',
        brand: 'Brand',
      },
    },
    detail: {
      closeTooltip: 'Close',
      printTooltip: 'Print',
      mailTooltip: 'Send mail',
      telephoneTooltip: 'Call number',
      faxTooltip: 'Send fax',
      websiteTooltip: 'Open website',
      fairBooths: {
        headline: 'Fair booths',
        hall: 'Hall',
        booth: 'booth',
        aisle: 'aisle',
        link: 'Hallplan',
        undefined: 'Undefined',
        ebmsState: {
          MAU: 'co-exhibitors',
          VF: 'represented company',
          AUS: 'main exhibitors',
        },
      },
      companyProfile: {
        headline: 'Company profile',
      },
      badges: {
        headline: 'Special awards',
      },
      contact: {
        headline: 'Contact',
      },
      pointOfContact: {
        headline: 'Point of contact',
      },
      products: {
        headline: 'Products',
        link: 'go to product',
      },
      news: {
        headline: 'News',
        link: 'go to news',
        exhibitor: 'Exhibitor',
      },
      categories: {
        headline: 'Categories',
      },
      travelDestinations: {
        headline: 'Travel destinations',
      },
      media: {
        headline: 'Media',
        download: 'Download',
        show: 'View now',
        back: 'Back to exhibitor',
      },
      brands: {
        headline: 'Brands',
      },
    },
  },
  it: {
    global: {},
    filter: {},
    list: {},
    detail: {},
  },
  fr: {
    global: {},
    filter: {},
    list: {},
    detail: {},
  },
  fa: {
    global: {},
    filter: {},
    list: {},
    detail: {},
  },
};

export default labels;
